export default "__VITE_ASSET__DKeNntSZ__"